<template lang="pug">
page(
    main-title="Товары"
)
    template(slot="description") Загрузка параметров 
        span.text-bold товаров
    .panel
        .panel-body
            .row
                .col-md-6                 
                    .row
                        .col-md-12
                            span Вы можете загрузить файл с данными в форматах 
                                | <code>xlsx</code> или <code>csv</code>. 
                                | Данные должны иметь вид как в примерах: 
                                a(:href="downloadBaseUrl + 'xlsx&example=true'", target="_blank") пример.xlsx
                                span , 
                                a(:href="downloadBaseUrl + 'csv&example=true'", target="_blank") пример.csv
                                span .
                    .row
                        .col-md-12
                            .checkbox.clip-check.check-primary
                                input#delete_existed(type="checkbox", v-model="deleteExisted")
                                label(for="delete_existed", style="word-wrap: break-word;") 
                                    | Удалить загруженные ранее данные

                    .row(:style="{'margin-bottom': errors.upload ? '10px' : '20px' }")
                        .col-md-12
                            span#file-upload.btn.btn-default.fileinput-button(
                                data-style='expand-right',
                                @click="uploadWrapper",
                                :disabled="uploading.inProgress"
                            )
                                span.ladda-label Загрузить файл
                                input(type="file", 
                                      accept=".csv,.xlsx,.xlsm,.xltx,.xltm", 
                                      @change="upload")
                    .row.margin-bottom-20(v-if="errors.upload")
                        .col-md-12
                            span.help-block.error {{ errors.upload }}

                .col-md-6                 
                    .row
                        .col-md-12
                            span Также Вы можете скачать файл с данными, которые 
                                | уже загружены в систему:
                    .row.margin-top-10
                        .col-md-12
                            button.btn.btn-default.dropdown-toggle(data-toggle="dropdown") 
                                | Скачать файл 
                                span.caret
                            ul.dropdown-menu(role='menu')
                                li.dropdown-header(role='presentation')
                                    | Выберите формат
                                li
                                    a(:href="downloadBaseUrl + 'xlsx'", target="_blank") xlsx
                                li
                                    a(:href="downloadBaseUrl + 'csv'", target="_blank") csv
    
</template>

<script>
import ajaxRequest from '@/utils/request';

import ladda from 'ladda';
import swal from 'sweetalert';

export default {
    name: 'Products',
    mounted() {
        let uploadingLadda = ladda.create(document.querySelector('#file-upload'));
        this.uploading.ladda = uploadingLadda;
    },
    methods: {
        uploadWrapper(event) {
            let fileField = document.querySelector('#file-upload input');
            if (event.target !== fileField) {
                fileField.click();
                event.stopPropagation();
            }
        },
        upload(event) {
            let file = event.target.files[0];

            let formData = new FormData();
            formData.append('products_file', file);
            formData.append('delete_existed', this.deleteExisted);

            this.startUploading();

            ajaxRequest({
                url: '/products/upload/',
                method: 'POST',
                params: formData,
                success: (response) => {
                    event.target.value = null;
                    this.errors.upload = null;

                    swal({
                        icon: 'success',
                        title: 'Файл загружен!',
                        buttons: {
                            confirm: {
                                text: 'Окей',
                                visible: true,
                                className: 'btn btn-o btn-default'
                            }
                        }
                    });
                    this.stopUploading();
                },
                failure: (response) => {
                    event.target.value = null;
                    this.errors.upload = response.errorMessage;

                    this.stopUploading();
                }
            });
        },
        startUploading() {
            this.uploading.inProgress = true;
            this.uploading.ladda.start();
        },
        stopUploading() {
            this.uploading.inProgress = false;
            this.uploading.ladda.stop();
        }
    },
    computed: {
        downloadBaseUrl() {
            let shopNumber = this.$store.state.localStorage.selectedShop.number;
            return `${process.env.DJANGO_HOST}/products/download/?shop_number=${shopNumber}&extension=`;
        }
    },
    data() {
        return {
            errors: {
                upload: null
            },

            deleteExisted: true,

            uploading: {
                inProgress: false,
                ladda: null
            }
        };
    }
};
</script>

<style>
#file-upload .ladda-spinner div[role="progressbar"] {
    background: red;
    filter: invert(50%)!important;
}
</style>


// WEBPACK FOOTER //
// src/components/products/Products.vue